

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://2960adcdd7704551bff19823820fca44@sentry.wixpress.com/819", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/fe2dae95a4dce98a/packages/viewer/src/components/live-video/Widget/index.tsx';
    import createController from '/home/builduser/work/fe2dae95a4dce98a/packages/viewer/src/components/live-video/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'live-video';
    var projectName = 'live-video-viewer';
    var sentryConfig = {
      DSN: 'https://2960adcdd7704551bff19823820fca44@sentry.wixpress.com/819',
      id: 'undefined',
      projectName: 'undefined',
      teamName: 'undefined',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/fe2dae95a4dce98a/packages/viewer/src/components/live-video/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["viewer-apps-2608697e-067a-44e2-8250-8e390df5bf71"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/fe2dae95a4dce98a/packages/viewer/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hu","id","it","ja","ko","lt","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"pagesPanel.mainPage.title":"Live Video","notification.reactionText":"reacted","joinedMeeting":"joined","recording":"Recording","recordingAbbrev":"Rec","recordingStarted":"The host started recording","recordingStopped":"The host stopped recording","justLeft":"left","meetingStarted":"Meeting Started","meetingHostWillStartSoon":"The host will start the meeting soon","webinarStarted":"Webinar Started","webinarHostWillStartSoon":"The host will start the webinar soon","joinWebinar":"Join Webinar","joinMeeting":"Join Meeting","waitingFormInputLabel":"Your Name","waitingFormInputPlaceholder":"Enter your name or nickname","fieldRequired":"This field is required","speakerView":"Speaker View","gridView":"Grid View","exitFullScreen":"Exit Full Screen","enterFullScreen":"Enter Full Screen","muteMic":"Mute Mic","unmuteMic":"Unmute Mic","startVideo":"Start Video","stopVideo":"Stop Video","shareScreen":"Share Screen","stopSharing":"Stop Sharing","sharingScreen":"You're sharing your screen","leave":"Leave","reactions":"Reactions","chat":"Chat","settings":"Settings","background":"Background","changeName":"Change name","accessMessageLineOne":"Your camera and microphone are off.","accessMessageLineTwo":"Please allow access to them to turn on your sound & video.","permissionDeniedLineOne":"You haven’t allowed access to your camera and microphone","permissionDeniedLineTwo":"Go to your browser settings to give access to your camera and microphone, then refresh the page.","permissionDeniedLearnHow":"Learn How","errorPopupLearnHow":"Learn How","notSafariOnIOSPopupTitle":"This browser is not supported","notSafariOnIOSPopupLineOne":"Please use the Safari browser to join the live stream on your phone or use your computer.","permissionDeniedIOSPopupTitle":"Allow access to camera and microphone to join","permissionDeniedIOSPopupLineOne":"In order to join, please allow camera and microphone permissions on your browser and refresh the page.","errorPopupRefresh":"Refresh Page","accessButton":"Allow access","statusScreen.recordingEnded.title":"Recording ended","statusScreen.meetingEnded.title":"The meeting has ended","statusScreen.webinarEnded.title":"The webinar has ended","statusScreen.leftMeeting.title":"You left the meeting","statusScreen.leftWebinar.title":"You've left the webinar","statusScreen.joinedElsewhere.title":"You have joined this meeting elsewhere","statusScreen.bannedWebinar.title":"You’ve been removed from this webinar","statusScreen.bannedMeeting.title":"You’ve been removed from this meeting","statusScreen.action.goToSite":"Go to Site","statusScreen.action.rejoin":"Rejoin","settings.main":"Main","settings.design":"Design","settings.support":"Support","settings.liveVideoScreen":"Live Video Screen","settings.waitingScreen":"Waiting Screen","settings.endScreen":"End Screen","settings.camera":"Camera","settings.microphone":"Microphone","settings.speakers":"Speaker","appName":"Wix Live Video","settings.mainTabContent":"This page is where guests see your live broadcast. Customize backgrounds, color & more.","settings.mainTabButton":"Manage Live Video","settings.text":"Text","settings.titleTextColor":"Title Text Color","settings.backgroundImage":"Background Image","settings.backgroundColor":"Background Color","settings.back":"Back","settings.mobile.speakerView":"Change to speaker view","settings.mobile.gridView":"Grid view","settings.mobile.cameraSound":"Sound & Video","participants.label.me":"Me","participants.label.host":"Host","chat.scrollToNew":"Scroll To New","chat.message.justNow":"Just now","chat.message.pending":"Pending","chat.input.placeholder":"Write a message...","chat.empty":"Get the chat started","demoState.waitingRoom.title":"Live Video Title","demoState.waitingRoom.participantName":"Name Surname","settings.video.text":"Text","settings.video.titleColor":"Title Text Color","settings.video.backgroundImage":"Background Image","settings.video.imageOpacity":"Image Opacity","settings.design.waitingScreen.sectionTitle":"Waiting Screen","settings.design.waitingScreen.cardBackgroundColor":"Card color","settings.design.waitingScreen.titleText":"Title","settings.design.waitingScreen.dateText":"Date","settings.design.waitingScreen.inputText":"Input","settings.design.waitingScreen.statusText":"Time","settings.design.waitingScreen.buttonSectionTitle":"Button","settings.design.waitingScreen.buttonText":"Font style & color","settings.design.waitingScreen.buttonBackgroundColor":"Background opacity & color","settings.backgroundPicker.changeImage":"Change Image","settings.backgroundPicker.addImage":"Add Image","settings.design.waitingScreen.toggle":"Set different background","settings.design.waitingScreen.card":"Card","settings.design.waitingScreen.background":"Background","settings.design.waitingScreen.buttonCornerRadius":"Corner radius (px)","settings.design.waitingScreen.buttonBorderOpacityAndColor":"Border opacity & color","settings.design.waitingScreen.buttonBorderWidth":"Border width (px)","settings.design.endScreen.sectionTitle":"End Screen","settings.design.endScreen.buttonSectionTitle":"Button","settings.design.endScreen.cardColor":"Card Color","settings.design.endScreen.title":"Title","settings.design.endScreen.buttonFontAndColor":"Font style & color","settings.design.endScreen.buttonBackgroundColor":"Button Color","settings.design.endScreen.buttonBorderRadius":"Corner radius (px)","settings.support.gotQuestion":"Got a Question?","settings.support.email":"Send us an email","settings.support.gotoSupport":"Contact Customer Care","sidePanel.cameraSound.allowAccess":"To allow access to your camera and microphone go to browser settings and then refresh the page.","sidePanel.cameraSound.allowAccessLearnHow":"Learn how","sidePanel.cameraSound.webinarNotRequiredDevices":"This is a webinar. Your microphone and camera are turned off.","sidePanel.cameraSound.noCamera":"No Camera Selected","sidePanel.cameraSound.noMicrophone":"No Microphone Selected","sidePanel.cameraSound.noSpeaker":"No Speaker Selected","settings.design.waitingScreen.background.toggleDescription":"Switch the toggle on to set a different background for the waiting screen.","linkExpired.text":"This link is no longer valid.","linkExpired.button":"Back to Site","allowWebinarSound_title":"Allow webinar sound","allowWebinarSound_text":"To hear the host, please allow sound.","allowMeetingSound_title":"Allow Meeting Sound","allowMeetingSound_text":"Please allow sound from this meeting to hear other participants.","allowSound_buttonText":"Allow Sound","modal.unsupportedBrowser.title":"Your browser may need to be updated","modal.unsupportedBrowser.text":"Please try updating your browser to the latest version and try again","modal.testVideoParticipantLimit.title":"The maximum number of participants are already in the video test.","participantsCount":"Participants ({{count}})"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "2608697e-067a-44e2-8250-8e390df5bf71";
    var componentId = "62431fb9-0a00-435e-8f5a-b98a739fb315";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/fe2dae95a4dce98a/packages/viewer/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
